export const DEFAULT_ERROR_TEXT = "Something went wrong, please try again later";
export const INTERNAL_SERVER_ERROR = "Server error, please try again later";
export const BAD_REQUEST = "You are not allowed to do this operation";
export const NOT_FOUND = "The item wasn't found";